const values = [
  "Depto__de_Economia_Rural",
  "Depto__de_Engenharia_Agricola",
  "Depto__de_Engenharia_Florestal",
  "Depto__de_Fitopatologia",
  "Depto__de_Fitotecnia",
  "Depto__de_Solos",
  "Depto__de_Zootecnia",
  "Depto__de_Biologia_Animal",
  "Depto__de_Biologia_Geral",
  "Depto__de_Biologia_Vegetal",
  "Depto__de_Bioquimica_e_Biologia_Molecular",
  "Depto__de_Educacao_Fisica",
  "Depto__de_Entomologia",
  "Depto__de_Microbiologia",
  "Depto__de_Medicina_e_Enfermagem",
  "Depto__de_Nutricaoo_e_Saude",
  "Depto__de_Veterinaria",
  "Depto__de_Arquitetura_e_Urbanismo",
  "Depto__de_Engenharia_Civil",
  "Depto__de_Engenharia_Eletrica",
  "Depto__de_Engenharia_de_Producao_e_Mecanica",
  "Depto__de_Estatistica",
  "Depto__de_Fisica",
  "Depto__de_Informatica",
  "Depto__de_Matematica",
  "Depto__de_Quimica",
  "Depto__de_Tecnologia_de_Alimentos",
  "Depto__de_Administracao_e_Contabilidade",
  "Depto__de_Artes_e_Humanidades",
  "Depto__de_Ciencias_Sociais",
  "Depto__de_Comunicacao_Social",
  "Depto__de_Direito",
  "Depto__de_Economia",
  "Depto__de_Economia_Domestica",
  "Depto__de_Educacao",
  "Depto__de_Geografia",
  "Depto__de_Historia",
  "Depto__de_Letras"
];

const labels = [
  "Depto. de Economia Rural",
  "Depto. de Engenharia Agrícola",
  "Depto. de Engenharia Florestal",
  "Depto. de Fitopatologia",
  "Depto. de Fitotecnia",
  "Depto. de Solos",
  "Depto. de Zootecnia",
  "Depto. de Biologia Animal",
  "Depto. de Biologia Geral",
  "Depto. de Biologia Vegetal",
  "Depto. de Bioquímica e Biologia Molecular",
  "Depto. de Educação Física",
  "Depto. de Entomologia",
  "Depto. de Microbiologia",
  "Depto. de Medicina e Enfermagem",
  "Depto. de Nutrição e Saúde",
  "Depto. de Veterinária",
  "Depto. de Arquitetura e Urbanismo",
  "Depto. de Engenharia Civil",
  "Depto. de Engenharia Elétrica",
  "Depto. de Engenharia de Produção e Mecânica",
  "Depto. de Estatística",
  "Depto. de Física",
  "Depto. de Informática",
  "Depto. de Matemática",
  "Depto. de Química",
  "Depto. de Tecnologia de Alimentos",
  "Depto. de Administração e Contabilidade",
  "Depto. de Artes e Humanidades",
  "Depto. de Ciências Sociais",
  "Depto. de Comunicação Social",
  "Depto. de Direito",
  "Depto. de Economia",
  "Depto. de Economia Doméstica",
  "Depto. de Educação",
  "Depto. de Geografia",
  "Depto. de História",
  "Depto. de Letras"
];

const arr = values.map((value, index) => {
  const label = labels[index];
  return {
    value,
    label
  };
});
export default arr;



// WEBPACK FOOTER //
// ./src/pages/HomePage/UfvDeptos.tsx